"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCheckbox = void 0;
var React = __importStar(require("react"));
function IconCheckbox(props) {
    return (React.createElement("label", { style: { display: "inline-block", transition: "all .3s" } },
        React.createElement("input", { style: { opacity: 0 }, type: 'checkbox', onClick: props.onClick, checked: props.checked }),
        React.createElement("span", { className: props.iconContainerClassName ? props.iconContainerClassName : 'icon-container', style: props.iconContainerStyle }, props.checked ? React.createElement("span", { className: "checked-icon" }, props.checkedIcon) :
            React.createElement("span", { className: "unchecked-icon" }, props.uncheckedIcon))));
}
exports.IconCheckbox = IconCheckbox;
